import type { ExperienceAtfPromoVariant } from '../constants';

/**
 * Amplitude `label` for ATF promo cards; shared by click and view so values cannot drift.
 * The `agentic_ai` variant emits the legacy `ATF_agentic` label so historical Amplitude
 * dashboards/funnels keyed on the OG name stay intact.
 */
export function formatAtfPromoEventLabel(promoVariant: ExperienceAtfPromoVariant): string {
  if (promoVariant === 'agentic_ai') {
    return 'ATF_agentic';
  }
  return `ATF_${promoVariant}`;
}
